import { SuccessBookingPageQuery } from '@website/types/graphqlOperations';
import UserPhoneNumberUpdateForm from './UserPhoneNumberUpdateForm';

type Props = {
  user: SuccessBookingPageQuery['booking']['user'];
};

export default function UserPhoneNumberUpdate({ user }: Props) {
  return (
    <>
      <UserPhoneNumberUpdateForm user={user} hideLabel />
    </>
  );
}
